import { api } from "jiffy-api";
import { EventBus, Events } from "jiffy-store";
import initProductCompositionCountdown from "components/jiffy/products/product-composition-countdown";
import "./product-delivery-timeleft.scss";

const SELECTORS = {
  CONTAINER: ".js-product-delivery-timeleft",
  LOADER: ".js-product-delivery-timeleft-loader",
  DETAILS: ".js-product-delivery-timeleft-details",
  COUNTDOWN: ".js-product-delivery-timeleft-coundown",
  TITLE: ".js-product-delivery-timeleft-title",
  PRICE: ".js-product-delivery-timeleft-price",
  ACTIVE_COLOR_SLIDE: ".js-color-variant-selector-active"
};

const DEFAULTS = {
  sameDay: {
    title: "Get it Today",
    price: "+$14.99"
  },
  tomorrow: {
    title: "Get it Tomorrow",
    price: "+$9.99"
  },
  other: {
    title: "Get it :date:",
    price: "+$9.99"
  }
};

const $getContainers = () => document.querySelectorAll(SELECTORS.CONTAINER);

const getCurrentCompositionId = () => {
  const $activeSlide = document.querySelector(SELECTORS.ACTIVE_COLOR_SLIDE);
  return $activeSlide?.dataset?.compositionId || window.jiffy_made_product_props?.composition_id;
};

const toggleLoading = ($container, isLoading) => {
  $container.querySelector(SELECTORS.LOADER).classList.toggle("hidden", !isLoading);
  $container.querySelector(SELECTORS.DETAILS).classList.toggle("hidden", isLoading);
};

const loadCurrentCompositionDeliveryTime = async () => {
  const $containers = [...$getContainers()];
  $containers.forEach($container => toggleLoading($container, true));

  const compositionId = getCurrentCompositionId();
  const data = await api.print.estimatedDelivery({
    composition_id: compositionId
  });
  const timeleft = data?.composition_dates?.timeleft;
  const { date_with_day_name: dateWithDayName, date } =
    data?.composition_dates?.shipments?.[0] || {};
  if (!timeleft || !dateWithDayName) return;
  const normalizedDayName = dateWithDayName.toLowerCase();

  const { title, price } = (() => {
    if (normalizedDayName.includes("today")) {
      return DEFAULTS.sameDay;
    }
    if (normalizedDayName.includes("tomorrow")) {
      return DEFAULTS.tomorrow;
    }
    const dayName = date?.split(",")?.shift() || date;
    return { ...DEFAULTS.other, title: DEFAULTS.other.title.replace(":date:", dayName) };
  })();

  $containers.forEach($container => {
    const $countdown = $container.querySelector(SELECTORS.COUNTDOWN);
    const $title = $container.querySelector(SELECTORS.TITLE);
    const $price = $container.querySelector(SELECTORS.PRICE);

    $countdown.dataset.countdown = timeleft;
    $title.textContent = title;
    $price.textContent = price;
  });

  initProductCompositionCountdown();
  $containers.forEach($container => toggleLoading($container, false));
};

const init = () => {
  if (!$getContainers().length) return;

  loadCurrentCompositionDeliveryTime();

  EventBus.on(Events.PRODUCT_COLOR_SELECTED_FROM_SLIDER, loadCurrentCompositionDeliveryTime);
};

export default init;
